
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import  LeftSection  from "./layout/LeftSection";
import Chart from './chart/Chart';
const  Contact = (props) => {
  
  return (
    <>
                <div class="ivo-text-box ivo-section text-center">
        <h2 class="ivo-heading">
            <span class="color_title">Contact</span> US
        </h2>
        <p class="ivo-para">Lorem ipsum dolor sit amet, consectetur adipiscing elit, </p>
    </div>
    <section class=" contact-us">
        <div class="container-fluid ivo-ovrflow-hidden">
            <div class="row">
                <div  class="col-lg-6 contact-bg-color ">
                    <div class="contact-us-detail px-4">
                        <h2 class="other-heading">
                            Contact Information
                        </h2>
                        <p class="ivo-para">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore et dolore magna aliqua. </p>
                        <ul class="bottom-logo-content ">
                            <li>
                                <div><span class="footer-icon"><i class="fa-solid fa-location-dot"></i></span></div>
                                <div class="contact-li-detail"> <span class="footer-icon-content">Our Location </span>
                                    <p>
                                        C-124 Sector 5, Central Spine, Shastri Nagar, Jaipur, Rajasthan
                                    </p>
                                </div>
                            </li>
                            <li>
                                <span class="footer-icon"><i class="fa-solid fa-envelope"></i></span>
                                <div class="contact-li-detail"> <a href=""><span class="footer-icon-content">Email
                                            Address </span>
                                        <p>Info@yourdomain.com</p>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <span class="footer-icon"><i class="fa-sharp fa-solid fa-phone"></i></span>
                                <div class="contact-li-detail">
                                    <a href=""><span class="footer-icon-content">Phone</span>
                                        <p>9857123653</p>
                                    </a>

                                </div>
                            </li>


                        </ul>
                    </div>

                </div>
                <div class="col-lg-6 contact-bg-color contact-bg-color-v-2">
                    <div class="contact-form px-4">
                        <form>
                            <h4 class="fomr-heading">Get In Touch With Us</h4>
                            <div class="form-group">
                               <div class="form-detail-icons"> <input type="email" class="form-control my-form-control" placeholder="Your Name " />
                                <div class="form-icon">
                                    <i class="fa-solid fa-user"></i>
                                </div>
                               </div>
                               <p class="not-found-text "> <small id="emailHelp" class="form-text text-danger">We'll never
                                share your email with anyone else.</small></p>
                            </div>
                            <div class="form-group">
                                <div class="form-detail-icons"> <input type="email" class="form-control my-form-control" placeholder="Your Phone " />
                                 <div class="form-icon">
                                     <i class="fa-solid fa-user"></i>
                                 </div>
                                </div>
                                <p class="not-found-text "> <small id="emailHelp" class="form-text text-danger">We'll never
                                 share your email with anyone else.</small></p>
                             </div>
                             <div class="form-group">
                                <div class="form-detail-icons"> <input type="email" class="form-control my-form-control" placeholder="Your Email" />
                                 <div class="form-icon">
                                     <i class="fa-solid fa-user"></i>
                                 </div>
                                </div>
                                <p class="not-found-text "> <small id="emailHelp" class="form-text text-danger">We'll never
                                 share your email with anyone else.</small></p>
                             </div>


                             <div class="form-group">
                                <textarea class="form-control my-form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Your Message"></textarea>
                                <p class="not-found-text "> <small id="emailHelp" class="form-text text-danger">We'll never
                                 share your email with anyone else.</small></p>
                             </div>
                             <div class="text-center"><button class="btn ivo-site-btn inline-btn"><a href="">Send Message</a></button></div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </section>
    </>

  );
}

export default Contact;
